'use client'

import { FC, ReactNode, createContext, useContext, useMemo } from 'react'

import { Products } from '@/lib/api/dashboard/dashboard.types'
import type { UserSession } from '@/types/user'

type PlatformProviderProps = {
  children: ReactNode
  initialData: {
    hasMaestroViewAccess: boolean
    userSession: UserSession
    userNavigation: Products[]
  }
}

type PlatformContextType = {
  hasMaestroViewAccess: boolean
  userSession: UserSession
  userNavigation: Products[]
}

const PlatformContext = createContext<PlatformContextType | undefined>(undefined)

const PlatformProvider: FC<PlatformProviderProps> = (props) => {
  const { children, initialData } = props

  const value = useMemo(() => {
    return {
      hasMaestroViewAccess: initialData.hasMaestroViewAccess,
      userSession: initialData.userSession,
      userNavigation: initialData.userNavigation,
    }
  }, [
    initialData.hasMaestroViewAccess,
    initialData.userSession,
    initialData.userNavigation,
  ])

  return <PlatformContext.Provider value={value}>{children}</PlatformContext.Provider>
}

const usePlatform = () => {
  const context = useContext(PlatformContext)
  if (!context) {
    throw new Error('usePlatform must be used within a PlatformProvider')
  }
  return context
}

export { usePlatform }

export default PlatformProvider
